import React, { Component } from 'react';
import { Form, Button } from 'react-bootstrap';
import { appConfig } from '../../config';
import { toast, Flip } from 'react-toastify';
import './CreateOrderDrawer.css';

class CreateOrderDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chemists: [],
            products: [],
            selectedChemist: '',
            selectedProducts: [],
            productSearchTerm: '',
            chemistSearchTerm: '',
            isLoadingChemists: false,
            isLoadingProducts: false,
            isChemistDropdownOpen: false,
            isProductDropdownOpen: false,
            isSubmitting: false,
            trkDuratn: '0-3 Hours',
            payMode: 'Cash',
        };
        this.typingTimeout = null;
        this.typingTimeoutChemist = null;
    }

    componentDidMount() {
        if (this.props.show) {
            this.fetchChemists();
            this.fetchProducts('');
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            this.setState({
                selectedChemist: '',
                selectedProducts: [],
                chemistSearchTerm: '',
                productSearchTerm: '',
                isChemistDropdownOpen: false,
                isProductDropdownOpen: false,
            });
            this.fetchChemists();
            this.fetchProducts('');
        }
    }

    fetchChemists = async (searchTerm = '') => {
        this.setState({ isLoadingChemists: true });
        try {
            const token = localStorage.getItem('token');
            const url = searchTerm
                ? `${appConfig.ip}/users?role=chemist&search=${searchTerm}`
                : `${appConfig.ip}/users?role=chemist`;

            const res = await fetch(url, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await res.json();
            if (res.ok) {
                this.setState({ chemists: data.rows || data.data || data || [] });
            } else {
                throw new Error('Failed to fetch chemists');
            }
        } catch (error) {
            toast.error('Failed to load chemists', { autoClose: 3000, transition: Flip });
        } finally {
            this.setState({ isLoadingChemists: false });
        }
    };

    fetchProducts = async (searchTerm) => {
        this.setState({ isLoadingProducts: true });
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${appConfig.ip}/itemMaster?limit=10&search=${searchTerm}`, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await res.json();
            if (res.ok) {
                this.setState({ products: data.rows || data.data || data || [] });
            } else {
                throw new Error('Failed to fetch products');
            }
        } catch (error) {
            toast.error('Failed to load products', { autoClose: 3000, transition: Flip });
        } finally {
            this.setState({ isLoadingProducts: false });
        }
    };

    handleTrkDuratnChange = (e) => {
        this.setState({ trkDuratn: e.target.value });
    };

    handlePayModeChange = (e) => {
        this.setState({ payMode: e.target.value });
    };

    handleProductSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ productSearchTerm: value });

        if (this.typingTimeout) {
            clearTimeout(this.typingTimeout);
        }

        this.typingTimeout = setTimeout(() => {
            this.fetchProducts(value);
        }, 500);
    };

    handleChemistSearchChange = (e) => {
        this.setState({ chemistSearchTerm: e.target.value, selectedChemist: '' });
    };

    handleChemistSelect = (chemist) => {
        const name = chemist.orgName ? `${chemist.orgName}` : (chemist.orgName || chemist.name);
        this.setState({
            selectedChemist: chemist.id || chemist._id,
            chemistSearchTerm: name,
            isChemistDropdownOpen: false,
        });
    };

    handleProductSelect = (product) => {
        const { selectedProducts } = this.state;
        const productId = product.id || product._id;
        const existingProduct = selectedProducts.find(p => (p.item.id || p.item._id) === productId);

        if (existingProduct) {
            const nextProducts = selectedProducts.map(p => {
                if ((p.item.id || p.item._id) === productId) {
                    return { ...p, quantity: p.quantity + 1 };
                }
                return p;
            });
            this.setState({ selectedProducts: nextProducts, productSearchTerm: '', isProductDropdownOpen: false });
        } else {
            this.setState({
                selectedProducts: [...selectedProducts, { item: product, quantity: 1 }],
                productSearchTerm: '',
                isProductDropdownOpen: false,
            });
        }
    };

    handleQuantityChange = (productId, delta) => {
        const { selectedProducts } = this.state;
        const nextProducts = selectedProducts.map(p => {
            const pid = p.item.id || p.item._id;
            if (pid === productId) {
                const newQuantity = Math.max(1, p.quantity + delta);
                return { ...p, quantity: newQuantity };
            }
            return p;
        });
        this.setState({ selectedProducts: nextProducts });
    };

    handleQuantityTypeChange = (productId, e) => {
        let value = parseInt(e.target.value, 10);
        if (isNaN(value)) {
            value = '';
        }

        const { selectedProducts } = this.state;
        const nextProducts = selectedProducts.map(p => {
            const pid = p.item.id || p.item._id;
            if (pid === productId) {
                return { ...p, quantity: value };
            }
            return p;
        });
        this.setState({ selectedProducts: nextProducts });
    };

    handleQuantityBlur = (productId, e) => {
        let value = parseInt(e.target.value, 10);
        if (isNaN(value) || value < 1) {
            value = 1;
        }

        const { selectedProducts } = this.state;
        const nextProducts = selectedProducts.map(p => {
            const pid = p.item.id || p.item._id;
            if (pid === productId) {
                return { ...p, quantity: value };
            }
            return p;
        });
        this.setState({ selectedProducts: nextProducts });
    };

    handleRemoveProduct = (productId) => {
        const { selectedProducts } = this.state;
        const nextProducts = selectedProducts.filter(p => (p.item.id || p.item._id) !== productId);
        this.setState({ selectedProducts: nextProducts });
    };

    handleSubmit = async () => {
        if (this.state.isSubmitting) return;

        const { selectedChemist, selectedProducts, chemists } = this.state;
        const { orderTrk } = this.props;

        if (!selectedChemist) {
            toast.error('Please select a chemist', { autoClose: 3000, transition: Flip });
            return;
        }
        if (selectedProducts.length === 0) {
            toast.error('Please select at least one product', { autoClose: 3000, transition: Flip });
            return;
        }

        const chemistData = chemists.find(c => (c.id || c._id) === selectedChemist) || {};
        const chemistName = chemistData.orgName || (chemistData.name ? `${chemistData.name} ${chemistData.lName || ''}` : selectedChemist);

        let distributorId = '';
        let distributorName = '';
        try {
            const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
            distributorId =
                userDetails.role === 'employee' ? userDetails.distributor : userDetails.id;
            distributorName = userDetails.orgName || userDetails.name || '';
        } catch (e) { }

        const orderData = {
            orgType: "chemist",
            orderTrk: orderTrk || "normal",
            orderFrom: selectedChemist,
            orderFromName: chemistName,
            orderTo: distributorId,
            orderToName: distributorName,
            orderType: "purchase",
            payType: "payLater",
            payMode: this.state.payMode.toLowerCase()
        };

        if (orderTrk === 'urgent') {
            orderData.trkDuratn = `${this.state.trkDuratn} Hours` || '0-3 Hours';
        }

        this.setState({ isSubmitting: true });
        try {
            const token = localStorage.getItem('token');

            // Fetch Chemist Address Details
            try {
                const orgRes = await fetch(`${appConfig.ip}/orgProf/${selectedChemist}`, {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + token,
                    },
                });
                if (orgRes.ok) {
                    const orgData = await orgRes.json();
                    orderData.addr = orgData.addr1 || '';
                    orderData.city = orgData.city || '';
                    orderData.pincode = orgData.zip || '';
                } else {
                    orderData.addr = '';
                    orderData.city = '';
                    orderData.pincode = '';
                }
            } catch (err) {
                console.error("Failed to fetch chemist profile", err);
                orderData.addr = '';
                orderData.city = '';
                orderData.pincode = '';
            }

            const res = await fetch(appConfig.ip + '/purchaseOrder', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token,
                },
                body: JSON.stringify(orderData),
            });

            if (!res.ok) {
                throw new Error("Failed to create purchase order.");
            }

            const resJSON = await res.json();

            const itemList = selectedProducts.map(p => {
                const item = p.item;
                return {
                    cartId: item.id || item._id,
                    orderId: resJSON.id,
                    orderNo: resJSON.orderNo,
                    itemCode: item.id || item._id,
                    unitType: item.unitMeasure ? item.unitMeasure.id : undefined,
                    itemName: item.drugName || item.name || item.itemName,
                    unitRate: item.unitPrice || 0,
                    unitCost: item.unitCost || 0,
                    qntty: p.quantity,
                    avlblQntty: p.quantity,
                    batchNo: item.batchNo || '',
                };
            });

            const res2 = await fetch(appConfig.ip + '/orderDetails/bulk', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token,
                },
                body: JSON.stringify({ item: itemList }),
            });

            if (!res2.ok) {
                throw new Error("Failed to submit bulk order details.");
            }

            toast.success('Your order submitted successfully', { autoClose: 3000, transition: Flip });
            if (this.props.onSuccess) {
                this.props.onSuccess();
            }
            this.props.onClose();

        } catch (error) {
            toast.error('Failed to create order: ' + error.message, { autoClose: 3000, transition: Flip });
        } finally {
            this.setState({ isSubmitting: false });
        }
    };

    render() {
        const { show, onClose } = this.props;
        const { chemists, products, selectedChemist, productSearchTerm, chemistSearchTerm, selectedProducts, isChemistDropdownOpen, isProductDropdownOpen } = this.state;

        const filteredChemists = Array.isArray(chemists)
            ? chemists.filter(chemist => {
                const searchTarget = `${chemist.orgName || ''} ${chemist.name || ''} ${chemist.lName || ''} ${chemist.id || ''}`;
                return searchTarget.toLowerCase().includes((chemistSearchTerm || '').toLowerCase());
            })
            : [];


        const chemistsToShow = chemistSearchTerm
            ? filteredChemists                 // show searched results
            : chemists.slice(0, 5);            // show first 5 initially

        return (
            <>
                {/* Overlay backdrop */}
                <div
                    className={`create-order-drawer-overlay ${show ? 'open' : ''}`}
                    onClick={onClose}
                ></div>

                {/* Drawer panel */}
                <div className={`create-order-drawer ${show ? 'open' : ''}`}>
                    <div className="drawer-header">
                        <h5>Create Order</h5>
                        <button className="close-btn" onClick={onClose}>&times;</button>
                    </div>

                    <div className="drawer-body">
                        <Form>
                            {this.props.orderTrk === 'urgent' && (
                                <Form.Group>
                                    <Form.Label>Duration (Hours)</Form.Label>
                                    <Form.Control as="select" value={this.state.trkDuratn} onChange={this.handleTrkDuratnChange}>
                                        <option value="0-3">0-3 Hours</option>
                                        <option value="3-6">3-6 Hours</option>
                                    </Form.Control>
                                </Form.Group>
                            )}
                            <Form.Group>
                                <Form.Label>Payment Mode</Form.Label>
                                <Form.Control as="select" value={this.state.payMode} onChange={this.handlePayModeChange}>
                                    <option value="Cash">Cash</option>
                                    <option value="UPI">UPI</option>
                                </Form.Control>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Search Chemist</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="search-product-input"
                                    placeholder="Type to search chemist..."
                                    value={chemistSearchTerm}
                                    onChange={this.handleChemistSearchChange}
                                    onFocus={() => this.setState({ isChemistDropdownOpen: true })}
                                    onBlur={() => setTimeout(() => this.setState({ isChemistDropdownOpen: false }), 200)}
                                />
                                {isChemistDropdownOpen && chemistsToShow.length > 0 && (
                                    <div className="product-dropdown-list">
                                        {chemistsToShow.map((chemist, index) => {
                                            const name = chemist.orgName
                                                ? `${chemist.orgName}`
                                                : (chemist.orgName || chemist.name);

                                            const valId = chemist.id || chemist._id;

                                            return (
                                                <div
                                                    key={valId || index}
                                                    className="product-dropdown-item"
                                                    onClick={() => this.handleChemistSelect(chemist)}
                                                >
                                                    {name}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                                {isChemistDropdownOpen && chemistSearchTerm && filteredChemists.length === 0 && (
                                    <div className="text-muted mt-1 small">No chemists found</div>
                                )}
                            </Form.Group>

                            {selectedProducts.length > 0 && (
                                <div className="selected-products-container mt-3 mb-3">
                                    <h6>Selected Products</h6>
                                    {selectedProducts.map((p, idx) => {
                                        const item = p.item;
                                        const pId = item.id || item._id;
                                        const name = item.drugName || item.itemName || item.name;
                                        return (
                                            <div key={pId || idx} className="selected-product-item">
                                                <div className="product-info">
                                                    <strong>{name}</strong>
                                                    {item.drugCode && <span className="text-muted ml-2">({item.drugCode})</span>}
                                                </div>
                                                <div className="product-actions d-flex align-items-center">
                                                    <Button size="sm" variant="outline-secondary" onClick={() => this.handleQuantityChange(pId, -1)}>-</Button>
                                                    <Form.Control
                                                        type="number"
                                                        className="mx-2 text-center"
                                                        style={{ width: '60px', padding: '0.2rem' }}
                                                        value={p.quantity}
                                                        onChange={(e) => this.handleQuantityTypeChange(pId, e)}
                                                        onBlur={(e) => this.handleQuantityBlur(pId, e)}
                                                        min={1}
                                                    />
                                                    <Button size="sm" variant="outline-secondary" onClick={() => this.handleQuantityChange(pId, 1)}>+</Button>
                                                    <Button size="sm" variant="outline-danger" className="ml-3" onClick={() => this.handleRemoveProduct(pId)}>
                                                        <i className="fa fa-trash"></i>
                                                    </Button>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            <Form.Group>
                                <Form.Label>Search Product</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="search-product-input"
                                    placeholder="Type to search products..."
                                    value={productSearchTerm}
                                    onChange={this.handleProductSearchChange}
                                    onFocus={() => this.setState({ isProductDropdownOpen: true })}
                                    onBlur={() => setTimeout(() => this.setState({ isProductDropdownOpen: false }), 200)}
                                />

                                {isProductDropdownOpen && products && products.length > 0 && (
                                    <div className="product-dropdown-list">
                                        {Array.isArray(products) && products.map((product, index) => {
                                            const name = product.drugName || product.itemName || product.name || 'Unknown Product';
                                            const valId = product.id || product._id;
                                            return (
                                                <div
                                                    key={valId || index}
                                                    className="product-dropdown-item"
                                                    onClick={() => this.handleProductSelect(product)}
                                                >
                                                    {name} {product.drugCode ? `(${product.drugCode})` : ''}
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}
                                {isProductDropdownOpen && products && products.length === 0 && (
                                    <div className="text-muted mt-1 small">No products found</div>
                                )}
                            </Form.Group>
                        </Form>
                    </div>

                    <div className="drawer-footer">
                        <Button variant="secondary" onClick={onClose} style={{ marginRight: '10px' }} disabled={this.state.isSubmitting}>Cancel</Button>
                        <Button variant="primary" onClick={this.handleSubmit} disabled={this.state.isSubmitting}>
                            {this.state.isSubmitting ? 'Creating...' : 'Create'}
                        </Button>
                    </div>
                </div>
            </>
        );
    }
}

export default CreateOrderDrawer;
